export const SHOPIFY_API_ENDPOINT =
  "https://jhannahjewelry.myshopify.com/api/2024-01/graphql.json";
export const SHOPIFY_ACCESS_TOKEN = "47c3a479ed5baccb33a9c5141a28fe33";
export const SHOPIFY_STOCKIST_ACCESS_TOKEN =
  "51d40290c50fc767b36ae3a2579f2036";

export const DEFAULT_COUNTRY_CODE = "US";
